/** Used as temporary measure while legacy router is primary router */
export const HOME_ROUTE_OVERRIDE = 'homepage'

/** Locations needed for CRM wrapper processing */
export enum TABLocation {
  Mobi = 538,
  Desktop = 285,
}
